import { ImportStepState } from "src/app/import/base-import-step.component";
import { AggregationMethod } from "../preaggregation/aggregation-method";

export class BenchmarkSeriesItem
{
    public controlValue: string;
    public isOldControlValue: boolean;
    public isNewControlValue: boolean;
    public isEligibleAsForecast: boolean;
    public isCurrentlyEligibleAsForecast: boolean;
    public isSelectedAsForecast: boolean;

    public canStartMultiSelect: boolean;
    public canEndMultiSelect: boolean;
    public isMultiSelected: boolean;
}

export class BenchmarkSeries
{
    public name: string;
    public items: BenchmarkSeriesItem[];
    public isExclude: boolean;
}

export class FormCompAggregationSettingsViewItem {
    public name!: string;
    public aggregationMethod!: AggregationMethod;
    public weightColumnName!: string;
}

export class BenchmarkSeriesModel
{
    public stepState: ImportStepState;
    public series: BenchmarkSeries[];
    public oldControlValue: string;
    public newControlValue: string;
    public selectedSeriesName: string;
    public differentSeriesSelected: boolean;
    public previousSelectedSeries: string;
    public outcomeName: string;
    public someDimensionName: string;
    public formCompAggregationSettings: FormCompAggregationSettingsViewItem[];
}